import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { INDRASlideshowComponent } from '@ibe.components/common/slideshow/slideshow.indra.component';
import { ModalService, SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../../store';
import { getCurrencySymbol } from '@angular/common';

import { PassengersSegmentedCount } from '@ibe.models/passenger.model.indra.lib';
import { INDRAFeature } from '@ibe.models/ancillary.indra.model.lib';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';

import {
	BRAND_CODE_EXECUTIVE,
	BRAND_CODE_TOP_EXECUTIVE,
	SEATMAP_SEAT_TYPE_STANDARD,
	SEATMAP_SEAT_TYPE_PREFERED,
	SEATMAP_SEAT_TYPE_BUSINESS,
	BRAND_CODE_AWARD_EXECUTIVE,
	BRAND_CODE_STAR_ALLIANCE_BUSINESS,
	BRAND_CODE_STAR_ALLIANCE_FIRST,
	ANCILLARY_PRODUCT_GROUP_CODE_SEAT_RESERVATION,
	ANCILLARY_PRODUCT_SEAT,
	BUSINESS_SEATS,
	EXECUTIVE_SEATS,
	SESSION_VAR_KEY_LANGUAGE,
	DEFAULT_LANGUAGE,
	SESSION_VAR_KEY_MARKET,
	DEFAULT_MARKET,
	SPECIAL_CASE_MARKET_LANGUAGE_MAP,
	BRAND_CODE_PLUS,
	FLIGHT_HAUL_TYPE_MEDIUM
} from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';

@Component({
	selector: 'app-flight-details-seat',
	templateUrl: './details-seat.indra.component.html',
	styleUrls: ['./details-seat.component.scss']
})
export class INDRAFlightDetailsSeatComponent implements OnInit, OnDestroy {

	galleryImages = [
		{ path_url: './assets/images/ancillaries/seats/1.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/2.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/4.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/5.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/6.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/7.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/8.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/9.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/10.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/11.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/12.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/13.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/14.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/15.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/16.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/17.jpg', description: 'seat image' },
		{ path_url: './assets/images/ancillaries/seats/18.jpg', description: 'seat image' }
	];

	flight;
	flightIdentifier; // applicable only for review flow
	brand: string;
	feature: INDRAFeature;

	isAlive = true;

	passengers$: Observable<PassengersSegmentedCount> = this.store.select(fromStore.getMiniIBEPassengers);
	passengerList;

	seatingAreaType;
	equipment;
	durationInHours;
	hasOtherBrandWithEconomyExtra: boolean = false;
	itemPriceText = '';

	reviewFlights: boolean = false;
	timeToThinkFlights: boolean = false;
	isUserFF: boolean = false;
	_hasEdit = false;
	flightWithSegmentsOperatedByTAP;
	hasTAPOperatedFlight: boolean = false;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		private store: Store<any>,
		private modalService: ModalService,
		private ancillariesService: INDRAAncillariesService,
		private currencyService: INDRACurrencyService,
		private bookingService: INDRABookingService,
		private bookingSearchService: INDRABookingSearchService,
		private storage: INDRAStorageService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService
	) { }


	ngOnInit() {

		if (this.router.url.includes('/review-your-trip')) this.reviewFlights = true;
		if (this.router.url.includes('/time-to-think')) this.timeToThinkFlights = true;
		this.brand = this.route.snapshot.paramMap.get('brand');


		this.passengers$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					// generate generic passenger list according to type and count
					this.passengerList = this.ancillariesService.INDRA_generateGenericPassengerList(value);
				}
			});

		// Note: There are three flows where this sidebar will be shown - flight search result page, review your trip page, and in time to think page
		if (this.reviewFlights || this.timeToThinkFlights) {
			this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
			const flightObj = this.bookingService.INDRA_getBookedFlight(this.flightIdentifier);
			this.flight = this.bookingService.INDRA_getFlightRoute(flightObj);
			this.feature = this.bookingService.INDRA_getIncludedFeature(
				ANCILLARY_PRODUCT_GROUP_CODE_SEAT_RESERVATION, this.flight.idFlight.toString(), '');

			const isEconomyExtra = this.bookingService.INDRA_isFlightEcononomyExtra(flightObj.idFlight.toString());
			this.INDRA_setSeatingAreaType(this.brand, isEconomyExtra);

			this.flightWithSegmentsOperatedByTAP =
				this.bookingService.INDRA_getBookedFlightWithSegmentsOperatedByInterlineFlightsOnly(this.flightIdentifier);
			if (this.flightWithSegmentsOperatedByTAP && this.flightWithSegmentsOperatedByTAP.listSegment && this.flightWithSegmentsOperatedByTAP.listSegment.length > 0) {
				this.durationInHours = Math.floor(this.flightWithSegmentsOperatedByTAP.listSegment[0].duration / 60);
				this.equipment = this.flightWithSegmentsOperatedByTAP.listSegment[0].equipment;
				this.hasTAPOperatedFlight = true;
			} else {
				this.hasTAPOperatedFlight = false;
			}

			this._hasEdit = this.INDRA_showSeatSelectionButton();
		} else {
			// get flight and feature object from the data obj passed into the sidebarservice
			const parameters = this.sidebarService.getSidebarParameters();
			if (parameters && parameters.length) {
				this.flight = parameters[0].flightInfo;
				this.feature = parameters[0].feature;
			}

			this.INDRA_setSeatingAreaType(this.brand, this.feature.extra, this.feature.otherRelatedBrandIsExtra);
			this.flightWithSegmentsOperatedByTAP =
				this.bookingSearchService.INDRA_getTAPMostSignificantFlightSegment(this.flight);

			if (this.flightWithSegmentsOperatedByTAP) {
				this.durationInHours = Math.floor(this.flightWithSegmentsOperatedByTAP.duration / 60);
				this.equipment = this.flightWithSegmentsOperatedByTAP.equipment;
				this.hasTAPOperatedFlight = true;
			} else {
				const tapOperatedFlightSegments = this.bookingSearchService.INDRA_getBookedFlightWithSegmentsOperatedByInterlineFlightsOnly(this.flight);
				this.hasTAPOperatedFlight = tapOperatedFlightSegments && tapOperatedFlightSegments.length > 0 ? true : false;
			}
		}

		// this.INDRA_setAncillaryPrice(this.feature);
		this.INDRA_handleExecutiveGallery();
	}

	INDRA_handleExecutiveGallery() {
		if (this.flight) {
			const significantFlightSegment = this.bookingSearchService.INDRA_getTAPMostSignificantFlightSegment(this.flight);
			
			let haulType = significantFlightSegment ? significantFlightSegment.haul : null;
			let equipment = significantFlightSegment ? significantFlightSegment.equipment : null;

			if (significantFlightSegment &&
				haulType === FLIGHT_HAUL_TYPE_MEDIUM &&
				this.bookingSearchService.INDRA_isAirbusModel(equipment)) {
				return true;
			} else return false;
		}
	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		let urlNavigate;

		if (this.seatingAreaType === 'business') {
			switch (languageMap) {
				case 'pt':
				case 'ptbr':
					urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`).concat('a-bordo/voar-executiva');
					break;
				case 'en':
				case 'enus':
					urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`).concat('on-board/fly-business');
					break;
				case 'fr':
					urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`).concat('a-bord/voyager-business');
					break;
				case 'es':
					urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`).concat('a-bordo/volar-business');
					break;
				case 'it':
					urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`).concat('a-bordo/volare-business');
					break;
				case 'de':
					urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`).concat('an-bord/fliegen-business');
					break;
				case 'pl':
					urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`).concat('na-pokladzie/lot-business');
					break;
				default: 
					urlNavigate = urlIbeAdmin.replace('${lang}', `en`).replace('${market}', `pt`).concat('booking-information/book-your-favourite-seat');
					break;
			}
		} else {
			urlNavigate = urlIbeAdmin.replace('${lang}', `en`).replace('${market}', `pt`).concat('booking-information/book-your-favourite-seat');
		}

		return window.open(urlNavigate);
	}

	INDRA_checkIfFrequentFlyerUser() {
		const userData = this.storage.get('userData');
		this.isUserFF = this.bookingSearchService.INDRA_isFrequentFlyerMember(userData);
	}

	INDRA_setSeatingAreaType(brand, economyExtraFlag, hasOtherBrandWithEconomyExtra = false) {
		if (this.brand === BRAND_CODE_EXECUTIVE ||
			this.brand === BRAND_CODE_TOP_EXECUTIVE ||
			this.brand === BRAND_CODE_AWARD_EXECUTIVE ||
			this.brand === BRAND_CODE_STAR_ALLIANCE_BUSINESS ||
			this.brand === BRAND_CODE_STAR_ALLIANCE_FIRST) {
			this.seatingAreaType = SEATMAP_SEAT_TYPE_BUSINESS;
			this.hasOtherBrandWithEconomyExtra = false;
		} else {
			if (economyExtraFlag) {
				this.seatingAreaType = SEATMAP_SEAT_TYPE_PREFERED;
				this.hasOtherBrandWithEconomyExtra = true;
			} else {
				this.seatingAreaType = SEATMAP_SEAT_TYPE_STANDARD;
				this.hasOtherBrandWithEconomyExtra = hasOtherBrandWithEconomyExtra;
			}
		}

	}

	/*
	INDRA_setAncillaryPrice(feature) {
		if (feature && feature.type === 'available') {
			const currency = feature.currency ? this.currencyService.INDRA_getCurrencySymbol(feature.currency).unit : '';
			this.itemPriceText = feature.price ? `from ${feature.price} ${currency} per item` : '';
		}
	}
	*/

	INDRA_showSeatSelectionButton() {
		let flag = false;
		const activeBooking = this.storage.get('INDRABFMDataStorageService._activeBooking');
		const catalog = activeBooking['ancillaries-data'];
		if (catalog && catalog.bundleList && catalog.bundleList.length) {
			catalog.bundleList.forEach(bundle => {
				const seatCatalog = bundle.ancillaryList.filter(curr => curr.type === ANCILLARY_PRODUCT_SEAT);
				if (seatCatalog.length > 0) {
					flag = true;
				}
			});
		}
		return flag;
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	moveToSeatsSidebar() {
		this.sidebarService.openSidebar(['seatmap', { flight: this.flightIdentifier }]);
	}

	INDRA_openSlideshow(seatingArea) {
		this.galleryImages = this.bookingService.INDRA_getSeatImages(seatingArea, this.equipment, this.durationInHours);

		if (!this.reviewFlights && !this.timeToThinkFlights) {
			if (seatingArea !== SEATMAP_SEAT_TYPE_BUSINESS) {
				this.galleryImages.filter(img => img.description !== BUSINESS_SEATS && img.description !== EXECUTIVE_SEATS);
			} else {
				this.galleryImages.filter(img => img.description === BUSINESS_SEATS || img.description === EXECUTIVE_SEATS);
				if (this.INDRA_handleExecutiveGallery()) {
					this.galleryImages[0].path_url = './assets/images/ancillaries/seats/1-executive.jpg';
				}
			}
		}

		this.modalService.assignComponent(
			INDRASlideshowComponent,
			this.galleryImages
		);
		this.modalService.open();
	}

	/** Handles close action intention **/
	INDRA_handleClose() { this.closeSidebar(); }

	ngOnDestroy() {
		this.isAlive = false;
	}

	INDRA_printImage() {
		let IMAGE = 'free_seat_reservation.jpg';
		if (this.flight['options']) {
			IMAGE = (this.flight.options.brand === 'executive' || this.flight.options.brand === 'top-executive' || this.flight.options.brand === 'miles&go-executive') ? 'executive_seat.jpg' : 'free_seat_reservation.jpg';
		} else if (this.flight['cabin']) {
			IMAGE = this.flight.cabin === 'Business' ? 'executive_seat.jpg' : 'free_seat_reservation.jpg';
		}
		return 'url(assets/images/ancillaries/includes/' + IMAGE + ')';
	}
}
